import { actions, types } from './requests'
export const GETCUSTOMER_TYPES = {
    ...types('GETCUSTOMER'),
}
export const GETCUSTOMER_ACTIONS = {
    ...actions('GETCUSTOMER'),
}